module.exports = __webpack_public_path__ + "img/ZJ5294.941cd72b.png";